// extracted by mini-css-extract-plugin
export var nav = "Navigation-module--nav--2dqRU";
export var sticky = "Navigation-module--sticky--3PoK0";
export var isActive = "Navigation-module--isActive--1igQf";